import { ReactNode } from 'react';
import styled from 'styled-components';

interface IProps {
  children: ReactNode;
  style?;
}

interface ErrorMessageWrapperProps {
  children?: ReactNode;
  style?: any;
}

export const ErrorMessageWrapper = styled.label<ErrorMessageWrapperProps>`
  color: ${({ theme }) => theme.colors.dangerBtn};
  position: relative;
  font-size: 12px;
  margin-left: 8px;
  top: -4px;
`;

const ErrorMessage = ({ children, style }: IProps) => {
  if (!children) {
    return;
  }

  return <ErrorMessageWrapper style={style}>{children}</ErrorMessageWrapper>;
};

export default ErrorMessage;
